module.exports = __webpack_public_path__ + "static/media/30 - Bob Marley & The Wailers - Iron Lion Zion.b2d7057b.mp3";